// extracted by mini-css-extract-plugin
export var form = "_en-0";